import React, { Component } from "react";
import {
  withStyles,
  Typography,
  Dialog,
  DialogContent,
  Box,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import clsx from "clsx";
import { withRouter } from "react-router-dom";
import { CloseOutlined, Visibility, ChevronLeft, ChevronRight } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import TouchAppIcon from "@material-ui/icons/TouchApp";
import { Tooltip } from "@material-ui/core";
import TemplateMessagePreview from "../../commons/TemplateMessagePreview/templateMessagePreview";

const quickFilters = [
  "Last active - 24 hr window",
  "Created - This week",
  "Created - This month",
];
class TemplateMsgTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: false,
      openPreviewDialog: false,
      selectedTemplate: null,
    };
  }
  toggleDialog = () => {
    this.setState({ openDialog: !this.state.openDialog });
  };
  openTemplate = (e) => {
    const templates = [...this.props.templates];
    const foundIndex = templates.findIndex((x) => x._id == e._id);

    this.props.setTemplateId(templates[foundIndex]._id.toString());
  };

  togglePreviewDialog = (templateIdx) => {
    this.setState({
      openPreviewDialog: !this.state.openPreviewDialog,
      selectedTemplate: templateIdx,
    });
  };

  getFields = () => {
    return [
      {
        name: "Project Name",
        key: "assistantName",
      },
      {
        name: "Created At",
        key: "createdAt",
      },
      {
        name: "Template Name",
        key: "name",
      },
      {
        name: "Status",
        key: "status",
      },
      {
        name: "Rejected Reason",
        key: "rejectedReason",
      },
      {
        name: "Action",
        key: "action",
      },
    ];
  };

  render() {
    const { classes, templates, isLoading, type } = this.props;
    const { selectedTemplate, openPreviewDialog } = this.state;
    const fields = this.getFields();
    if (type === "DIRECT") fields.splice(1, 1);
    return (
      <div className={classes.root}>
        <table>
          <tbody>
            <tr className={`${classes.row} ${classes.topbar}`}>
              {fields.map((field, index) => (
                <th
                  key={index}
                  className={clsx(classes.column, classes.dataColumn)}
                >
                  <Typography variant="h5" color="primary" align="center">
                    {field.name.toUpperCase()}
                  </Typography>
                </th>
              ))}
            </tr>
            {isLoading ? (
              <React.Fragment>
                {[1, 2, 3, 4, 5, 6, 7].map((e, index) => (
                  <tr className={clsx(classes.row)} key={index}>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((field, index) => (
                      <th
                        key={index}
                        className={clsx(
                          classes.column,
                          classes.dataColumn,
                          classes[field.width]
                        )}
                      >
                        <Skeleton style={{ width: "100%" }} height={40} />
                      </th>
                    ))}
                  </tr>
                ))}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {templates.map((e, index) => (
                  <tr
                    key={index}
                    className={clsx(classes.row, classes.dataRow, {
                      [classes.alterRow]: index % 2 == 0,
                    })}
                  >
                    {fields.map((field, idx) => (
                      <th
                        key={idx}
                        style={{ width: "20%", overflow: "hidden" }}
                        className={clsx(classes.column, classes.dataColumn)}
                        onClick={() => this.openTemplate(e)}
                      >
                        {columnType(
                          classes,
                          e,
                          index,
                          field,
                          this.togglePreviewDialog
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </React.Fragment>
            )}
          </tbody>
        </table>
        {openPreviewDialog && (
          <PreviewDialog
            template={templates[selectedTemplate]}
            togglePreviewDialog={this.togglePreviewDialog}
          />
        )}
      </div>
    );
  }
}

function columnType(classes, columnData, idx, fieldName, togglePreviewDialog) {
  const key = fieldName.key;
  switch (key) {
    case "assistantName":
      return (
        <Typography variant="body1" align="center">
          {columnData[key]}
        </Typography>
      );
      break;
    case "createdAt":
      return (
        <Typography variant="body1" align="center">
          {getFormattedDate(columnData[key])}
        </Typography>
      );
      break;
    case "name":
      return (
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography variant="body1" align="center" noWrap>
            {columnData[key]}
          </Typography>
          {columnData.isClickTrackingEnabled && (
            <Tooltip title="Click tracking is enabled for this template">
              <TouchAppIcon style={{ fontSize: 16, color: "grey", marginLeft: 4 }} />
            </Tooltip>
          )}
        </Box>
      );
      break;
    case "status":
      return (
        <Typography variant="body1" align="center">
          {columnData[key]}
        </Typography>
      );
      break;
    case "rejectedReason":
      return (
        <Typography variant="body1" align="center">
          {columnData[key] ? columnData[key] : "Unmarked"}
        </Typography>
      );
      break;
    case "action":
      return (
        <Visibility
          onClick={(e) => {
            togglePreviewDialog(idx);
            e.stopPropagation();
          }}
        />
      );

      break;
    default:
      return (
        <Typography variant="body1" align="center">
          {columnData[key] || "-"}
        </Typography>
      );
  }
}

const PreviewDialog = ({ template, togglePreviewDialog }) => {
  const [carouselIndex, setCarouselIndex] = React.useState(0);
  // Normalize template for preview
  const normalizedTemplate = React.useMemo(() => {
    if (!template) return template;

    let callToAction = template.callToAction || [];
    let actionType = template.actionType || "None";

    // Convert buttons array to callToAction format for preview
    if (template.buttons && template.buttons.length > 0) {
      const mappedButtons = template.buttons.map((btn) => {
        if (btn.type === "QUICK_REPLY") {
          return { type: "QUICK_REPLY", buttonTitle: btn.text, buttonValue: "" };
        }
        if (btn.type === "COPY_CODE") {
          return { type: "COPY_CODE", buttonTitle: "Copy Code", buttonValue: btn.example || "" };
        }
        if (btn.type === "PHONE_NUMBER") {
          const phone = btn.phone_number || ((btn.phoneMetadata?.extension || "") + (btn.phoneMetadata?.number || ""));
          return { type: "Phone Number", buttonTitle: btn.text, buttonValue: phone };
        }
        if (["URL", "url"].includes(btn.type)) {
          return { type: "URL", buttonTitle: btn.text, buttonValue: btn.url || "" };
        }
        return { type: btn.type, buttonTitle: btn.text || "", buttonValue: "" };
      });
      callToAction = mappedButtons;
      actionType = "All";
    }

    // If callToAction exists but actionType is missing/None, set it to CAT
    if (callToAction.length > 0 && actionType === "None") {
      actionType = "CAT";
    }

    // Handle format from quickReplies appended with " | [reply]" syntax
    let format = template.format || "";
    if (format.includes(" | [") && actionType !== "All") {
      actionType = "CAT";
    }

    // Normalize CAROUSEL: convert carousel_cards → carouselTemplates + carouselButtons + carouselMediaType
    let carouselTemplates = template.carouselTemplates;
    let carouselButtons = template.carouselButtons;
    let carouselMediaType = template.carouselMediaType || "IMAGE";

    if (template.type === "CAROUSEL" && !carouselTemplates) {
      const cards = template.carousel_cards || template.carouselCards || [];
      carouselTemplates = [];
      carouselButtons = [];
      cards.forEach((card) => {
        const comps = card.components || [];
        const header = comps.find((c) => c.type === "HEADER");
        const body = comps.find((c) => c.type === "BODY");
        const btnComp = comps.find((c) => c.type === "BUTTONS");
        if (header && header.format) carouselMediaType = header.format;
        carouselTemplates.push({
          templateFooter: body ? body.text : "",
          parameters: body?.example?.body_text?.[0] || [],
        });
        carouselButtons.push(
          btnComp
            ? btnComp.buttons.map((b) => {
                if (b.type === "QUICK_REPLY") return { type: "QUICK_REPLY", text: b.text || "" };
                if (b.type === "URL") return { type: "URL", text: b.text || "", url: b.url || "" };
                if (b.type === "PHONE_NUMBER") return { type: "PHONE_NUMBER", text: b.text || "", number: b.phone_number || "" };
                return { type: b.type, text: b.text || "" };
              })
            : []
        );
      });
    }

    // Normalize LTO: pass limitedTimeOffer, ltoButtons, headerType
    const ltoButtons = template.buttons || [];
    const headerType = template.headerType || template.templateHeaderType || "";

    return {
      ...template,
      format,
      actionType,
      callToAction,
      ...(template.type === "CAROUSEL"
        ? { carouselTemplates, carouselButtons, carouselMediaType }
        : {}),
      ...(template.type === "LIMITED_TIME_OFFER"
        ? { ltoButtons, headerType }
        : {}),
    };
  }, [template]);

  return (
    <Dialog open={true}>
      <DialogContent style={{ display: "flex", flexDirection: "column" }}>
        <Box
          style={{
            width: "100%",
            height: "20px",
            display: "flex",
            justifyContent: "flex-end",
            cursor: "pointer",
          }}
        >
          <CloseOutlined onClick={togglePreviewDialog} />
        </Box>
        <Box
          style={{
            width: window.innerWidth >= 768 ? "300px" : "200px",
            padding:
              window.innerWidth >= 768
                ? `40px 60px ${normalizedTemplate?.sampleCTAUrl ? 0 : "60px"} 60px`
                : window.innerWidth >= 350
                ? `20px 40px ${normalizedTemplate?.sampleCTAUrl ? 0 : "20px"} 40px`
                : 0,
          }}
        >
          {normalizedTemplate?.type === "CAROUSEL" ? (
            <Box style={{ position: "relative" }}>
              {/* Left arrow */}
              <IconButton
                size="small"
                disabled={carouselIndex === 0}
                onClick={() => setCarouselIndex(carouselIndex - 1)}
                style={{ position: "absolute", left: -36, top: "50%", transform: "translateY(-50%)", zIndex: 1 }}
              >
                <ChevronLeft />
              </IconButton>

              <TemplateMessagePreview
                parameters={[]}
                media={""}
                bigIcon={true}
                selectedTemplate={normalizedTemplate}
                showDisclaimer={false}
                carouselIndex={carouselIndex}
                setCarouselIndex={setCarouselIndex}
              />

              {/* Right arrow */}
              <IconButton
                size="small"
                disabled={carouselIndex === (normalizedTemplate.carouselTemplates?.length ?? 1) - 1}
                onClick={() => setCarouselIndex(carouselIndex + 1)}
                style={{ position: "absolute", right: -36, top: "50%", transform: "translateY(-50%)", zIndex: 1 }}
              >
                <ChevronRight />
              </IconButton>

              {/* Dots */}
              <Box display="flex" justifyContent="center" style={{ gap: 6, marginTop: 8 }}>
                {(normalizedTemplate.carouselTemplates || []).map((_, idx) => (
                  <Box
                    key={idx}
                    onClick={() => setCarouselIndex(idx)}
                    style={{
                      width: 8, height: 8, borderRadius: "50%",
                      background: idx === carouselIndex ? "#333" : "#bbb",
                      cursor: "pointer",
                    }}
                  />
                ))}
              </Box>
            </Box>
          ) : (
            <TemplateMessagePreview
              parameters={[]}
              media={""}
              bigIcon={true}
              selectedTemplate={normalizedTemplate}
              showDisclaimer={false}
            />
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

function getFormattedDate(date) {
  const d = new Date(date);
  const options = { year: "numeric", month: "long", day: "numeric" };
  return d.toLocaleDateString("en-US", options);
}
const styles = (theme) => ({
  root: {
    height: "100%",
    width: "100%",
    overflowX: "auto",
    overflowY: "auto",
    boxSizing: "border-box",
    borderRadius: "8px",
    position: "relative",
    border: "1px solid lightgrey",
    background: "white",
    paddingBottom: "60px",
    [theme.breakpoints.down("sm")]: {
      // height: "calc(100vh - 60px)",
    },
    "& table": {
      borderCollapse: "collapse",
      borderSpacing: 0,
      width: "100%",
      background: "white",
    },
  },
  row: {
    background: "white",
    display: "flex",
  },
  alterRow: {
    background: "rgb(246,246,246)",
  },
  dataRow: {
    cursor: "pointer",
    transition: "0.3s",
    "&:hover": {
      background: "rgb(237, 226, 252)",
    },
  },
  topbar: {
    background: "rgb(252,252,252)",
    position: "sticky",
    top: "0",
    zIndex: "100",
  },
  column: {
    // width: "4400px",
    fontWeight: "normal",
    height: "50px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    boxSizing: "border-box",
  },
  dataColumn: {
    width: "200px",
    // minHeight: "80px",
    // display: "flex",
    // background: "red"
    // flexWrap: "wrap"
  },
  checkboxColumn: {
    width: "60px",
    // background: "red"
  },
});

export default withStyles(styles)(withRouter(TemplateMsgTable));
